export default {"src":"/_next/static/media/width-icon.e040b572.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};